module.exports = __webpack_public_path__ + "images/fa-mw-bg-pricing-site-mobile.webp";